import { apiClient } from './api-client';
import { ApiResponse } from '../dtos/common/api.dto';
import { SystemConfigData, UpdateSystemConfigRequest } from '../dtos/admin/systemConfig.dto';

export class ConfigService {
  static async getConfig(): Promise<SystemConfigData> {
    try {
      const response: ApiResponse<SystemConfigData> = await apiClient.get('/admin/config');
      if (response.success && response.data) {
        return response.data;
      }
      throw new Error(response.error?.message || 'Failed to fetch configuration');
    } catch (error) {
      console.error('Error fetching system config:', error);
      throw error;
    }
  }

  static async updateConfig(updates: UpdateSystemConfigRequest): Promise<SystemConfigData> {
    try {
      const response: ApiResponse<SystemConfigData> = await apiClient.put('/admin/config', updates);
      if (response.success && response.data) {
        return response.data;
      }
      throw new Error(response.error?.message || 'Failed to update configuration');
    } catch (error) {
      console.error('Error updating system config:', error);
      throw error;
    }
  }
}
